<template>
  <div>
    <el-card shadow="always">
      <div>
        <el-row class="uploadWrapper" :gutter="5">
          <el-col>
            <el-upload
              class="upload-demo"
              drag
              action="/api/import/upload/"
              :multiple="false"
              :limit="1"
              ref="file"
              :file-list="fileList"
              :on-success="uploadAndCompare"
              :style="hasError ? 'width: 60%' : ''"
              :on-remove="
                () => {
                  isEqual = false;
                  hasFile = false;
                  hasError = false;
                  error.values = [];
                  mandatoryColumns = [];
                  fileFields = '';
                }
              "
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Arraste o arquivo ou <em>clique para aqui para enviar</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                Arquivos csv/txt com a listagem de Clientes
              </div>
            </el-upload>
          </el-col>
          <el-col v-if="hasError">
            <el-card class="errorReport">
              <span>{{ error.error ? error.error : "" }}</span>
              <div class="reportTable">
                <el-table
                  :data="error.values"
                  style="width: 100%"
                  height="150"
                  v-if="
                    mandatoryColumns.length === 0 || error.values.length > 0
                  "
                >
                  <el-table-column prop="pos" label="Coluna" width="100">
                  </el-table-column>
                  <el-table-column prop="file" label="No Layout" width="180">
                  </el-table-column>
                  <el-table-column prop="layout" label="No Arquivo" width="180">
                  </el-table-column>
                </el-table>

                <el-table
                  :data="mandatoryColumns"
                  style="width: 100%"
                  height="150"
                  v-if="
                    mandatoryColumns.length > 0 && error.values.length === 0
                  "
                >
                  <el-table-column
                    prop="col"
                    label="Coluna"
                    width="460"
                    align="center"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </el-card>
          </el-col>
        </el-row>

        <el-row :gutter="5" style="margin-top: 50px">
          <el-col
            :xs="12"
            :sm="12"
            :md="12"
            :lg="12"
            :xl="6"
            :offset="11"
            style="display: flex; justify-content: center"
          >
            <el-button
              type="warning"
              ref="finish"
              @click="finish()"
              :disabled="!hasFile"
              >Finalizar</el-button
            >
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
import { UserService } from "@/services/users/user.services";

export default {
  name: "ImportCustomer",
  props: ["state"],
  props: ["type"],
  methods: {
    async uploadAndCompare() {
      // const vm = this;
      // const file = vm.$refs.file.uploadFiles[0].raw;
      // if (file) {
      //   vm.hasFile = true;
      // }
      // const fileData = new FormData();
      // fileData.append('file', file);
      // const fileResponse = await UploadService.upload(fileData);
      // if (vm.dataAnalyze(fileResponse)) {
      //   vm.createPrepost(fileResponse);
      // }
    },

    dataAnalyze(file) {
      // const vm = this;
      // vm.fileFields = Object.keys(file[0]).sort();
      // vm.importForm.fields = vm.importForm.fields.sort();
      // if (vm.importForm.fields.length === vm.fileFields.length) {
      //   vm.importForm.fields.forEach((field, index) => {
      //     if (field !== vm.fileFields[index]) {
      //       vm.error.error = 'Colunas com valores distintos.';
      //       vm.error.values.push({
      //         pos: index + 1,
      //         file: vm.fileFields[index],
      //         layout: field,
      //       });
      //       vm.hasError = true;
      //     }
      //   });
      //   vm.mandatoryProperties.forEach((prop) => {
      //     if (!file[0].hasOwnProperty(prop)) {
      //       vm.error.error = 'Colunas obrigatórias não foram enviadas';
      //       vm.mandatoryColumns.push({
      //         col: prop,
      //       });
      //       vm.hasError = true;
      //     } else if (!vm.importForm.fields.includes(prop)) {
      //       vm.mandatoryColumns.push({
      //         col: prop,
      //       });
      //       vm.hasError = true;
      //     }
      //   });
      //   if (vm.hasError) {
      //     this.$message({
      //       type: 'error',
      //       message: vm.error.error,
      //     });
      //     return;
      //   }
      //   this.$message({
      //     type: 'success',
      //     message: 'Arquivo compatível.',
      //   });
      //   vm.isEqual = true;
      //   vm.error = {
      //     error: '',
      //     values: [],
      //   };
      //   return true;
      // } else {
      //   vm.error.error = `
      //   Quantidade de Colunas incompatíveis.
      //   LAYOUT: ${vm.importForm.fields.length},
      //   ARQUIVO: ${vm.fileFields.length}`;
      //   this.$message({
      //     type: 'error',
      //     message: vm.error.error,
      //   });
      //   vm.isEqual = false;
      //   return false;
      // }
    },

    async createPrepost(file) {
      // const vm = this;
      // const analyze = file.map(async (data, index) => {
      //   await vm.setPrepostData(data, index);
      //   return true;
      // });
      // Promise.all(analyze).then((response) => {
      //   console.log(response);
      //   if (response.includes(false)) {
      //     this.$message({
      //       type: 'error',
      //       message: vm.error.error,
      //     });
      //   }
      // });
    },

    setPrepostData(data, index) {
      // const vm = this;
      // let prepostData = {
      //   prepost: {
      //     customer: '',
      //     service: '',
      //     sender: {},
      //     sender: {},
      //     delivery: {},
      //     contact: {},
      //     object: {},
      //   },
      // };
      // UploadService.getServiceData(data.SERVICO).then((res) => {
      //   console.log('SERVICE', res);
      //   if (!res) {
      //     vm.error.error = `Serviço não localizado. LINHA ${index + 1}`;
      //     return false;
      //   }
      //   prepostData.prepost.service = res.id;
      // });
      // PostOfficeService.zipcode(data.CEP_REM).then((res) => {
      //   if (res) {
      //     prepostData.prepost.sender = {
      //       cep: res.zipcode.cep,
      //       contact: data.NOME_REM ? data.NOME_REM : '',
      //       address: res.zipcode.end,
      //       neighborhood: res.zipcode.bairro,
      //       city: res.zipcode.cidade,
      //       state: res.zipcode.uf,
      //       number: data.NUMERO_REM ? data.NUMERO_REM : '',
      //       extent: '',
      //     };
      //   }
      // });
      // PostOfficeService.zipcode(data.CEP, 'delivery').then((res) => {
      //   console.log('DELIVERY', res);
      //   if (res) {
      //     prepostData.prepost.delivery = {
      //       delivery: 1,
      //       branch: '',
      //       department: data.DEPARTAMENTO ? data.DEPARTAMENTO : '',
      //       cep: res.zipcode.cep,
      //       contact: '',
      //       address: res.zipcode.end,
      //       neighborhood: res.zipcode.bairro,
      //       city: res.zipcode.cidade,
      //       state: res.zipcode.uf,
      //       number: data.NUMERO ? data.NUMERO : '',
      //       extent: '',
      //       name: data.DESTINATARIO ? data.DESTINATARIO : '',
      //     };
      //   }
      // });
      // // CRIAÇÃO DA PRÉ-POSTAGEM
      // prepostData.prepost.contact = {
      //   save: '',
      //   invoice: data.NOTA ? data.NOTA : '',
      //   care: data.AC ? data.AC : '',
      //   mail: data.EMAIL_DESTINO ? data.EMAIL_DESTINO : '',
      //   phone: data.TELEFONE_DESTINO ? data.TELEFONE_DESTINO : '',
      // };
      // prepostData.prepost.object = {
      //   urg: data.URGENTE ? data.URGENTE : '',
      //   reg: data.REGISTRADO ? data.REGISTRADO : '',
      //   mdp: '',
      //   width: data.LARGURA ? +data.LARGURA : 0,
      //   height: data.ALTURA ? +data.ALTURA : 0,
      //   length: data.COMPRIMENTO ? +data.COMPRIMENTO : 0,
      //   weight: data.PESO,
      //   value: data.VALOR_DECLARADO ? data.VALOR_DECLARADO : '',
      //   package: data.EMBALAGEM ? data.EMBALAGEM : '',
      //   type: data.TIPO ? data.TIPO : '',
      // };
      // prepostData.prepost.customer = vm.importForm.customer;
      // vm.prepostList.push(prepostData);
      // console.log('lalala');
      // console.log(vm.prepostList);
    },

    finish() {
      const vm = this;
      // let success = 0;

      // const loading = vm.$loading({
      //   lock: true,
      //   text: i18n.tc('carregando'),
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)',
      // });

      // const sendPrepostData = async (data) => {
      //   return await PrepostService.add(
      //     data.prepost.customer,
      //     data.prepost.sender,
      //     data.prepost.delivery,
      //     data.prepost.contact,
      //     data.prepost.object,
      //     data.prepost.service
      //   );
      // };

      // vm.prepostList.forEach((list, index) => {
      //   retry(sendPrepostData, list)
      //     .then((res) => {
      //       console.log(res);
      //       this.$message({
      //         type: 'success',
      //         message: `Pré-Postagem da Linha ${++index} criada com sucesso!`,
      //       });
      //       ++success;
      //       console.log(success);

      //       if (success === vm.prepostList.length) {
      //         console.log('ACABOU');
      //         loading.close();

      //         setTimeout(() => {
      //           this.$message({
      //             type: 'success',
      //             message: 'Importação realizada com sucesso!',
      //           });
      //           if (vm.isCustomer) {
      //             vm.back();
      //           } else {
      //             this.$router.push('/cockpit/prepostagem/usuario');
      //             setTimeout(() => {
      //               window.scrollTo({ top: 700, behavior: 'smooth' });
      //             }, 1000);
      //           }
      //         }, 1000);
      //       }
      //     })
      //     .catch((err) => {
      //       console.log(err);
      //       vm.back();
      //       this.$message({
      //         type: 'error',
      //         message: `Pré-Postagem da Linha ${++index} falhou! Tentando novamente.`,
      //       });
      //     })
      //     .finally(() => loading.close());
      // });

      // if (vm.prepostList.length === success) {
      //   console.log('ACABOU');
      // }
    },

    save() {
      const vm = this;
      // if (vm.value.length == 0) {
      //   this.$message({
      //     type: 'error',
      //     message: 'Selecione ao menos um campo para salvar o layout',
      //   });
      //   return false;
      // }

      // this.$prompt('Informe um nome para o layout', 'Salvar', {
      //   confirmButtonText: 'OK',
      //   cancelButtonText: 'Cancel',
      //   inputPlaceholder: 'Informe um nome',
      //   inputErrorMessage: 'É obrigatório informar um nome',

      //   inputValidator: function(v) {
      //     console.log('inputValidator', v);
      //     if (!v) {
      //       return false;
      //     }
      //   },
      // })
      //   .then(async ({ value }) => {
      //     const loading = vm.$loading({
      //       lock: true,
      //       text: i18n.tc('carregando'),
      //       spinner: 'el-icon-loading',
      //       background: 'rgba(0, 0, 0, 0.7)',
      //     });

      //     const data = {
      //       name: value,
      //       fields: vm.value,
      //       type: vm.$props.type,
      //     };

      //     await LayoutService.add(data)
      //       .then(async (response) => {
      //         console.log(response);
      //         vm.importForm.layouts.push(response);
      //         this.$message({
      //           type: 'success',
      //           message: 'Layout salvo com sucesso',
      //         });
      //       })
      //       .catch((error) => {
      //         this.$message({
      //           type: 'error',
      //           message: error,
      //         });
      //       })
      //       .finally(() => loading.close());
      //   })
      //   .catch(() => {});
    },

    async next() {
      // const vm = this;
      // if (vm.importForm.use) {
      //   const layoutData = await LayoutService.get('nome', vm.importForm.use);
      //   vm.importForm.fields = layoutData[0].fields.split(',');
      // }
      // if (vm.value.length > 0) {
      //   if (vm.importForm.use) {
      //     let data = new Set();
      //     // prettier-ignore
      //     vm.importForm.fields.forEach((item) => data.add(item));
      //     vm.value.forEach((item) => data.add(item));
      //     vm.importForm.fields = Array.from(data);
      //   } else {
      //     vm.importForm.fields = vm.value;
      //   }
      // }
      // vm.active++;
    },

    back() {
      const vm = this;
      //   vm.active--;
      //   vm.error = {
      //     error: '',
      //     values: [],
      //   };
      //   vm.importForm.use = '';
      //   vm.value = [];
      //   vm.hasError = false;
      //   vm.isEqual = false;
      //   vm.mandatoryColumns = [];
      //   !vm.isCustomer ? (vm.importForm.customer = '') : '';
      //   vm.fileFields = '';
      //   vm.prepostList = [];
      // },

      // downloadSample() {
      //   window.open('/files/prepost-template.csv');
    },
  },
  computed: {
    isDisabled: function () {
      if (this.error.error !== "" || !this.hasFile) {
        return true;
      } else {
        return false;
      }
    },
  },
  data() {
    return {
      fileList: [],
      fileFields: "",
      me: {},
      importForm: {
        use: "",
        fields: "",
        layouts: [],
        customer: "",
        department: "",
      },
      filterMethod(query, item) {
        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
      },
      active: 0,
      value: [],
      customer: "",
      error: {
        error: "",
        values: [],
      },
      hasError: false,
      hasFile: false,
      isEqual: false,
      mandatoryColumns: [],
      mandatoryProperties: ["CEP", "CEP_REM", "PESO", "SERVICO"],
      prepostList: [],
      isCustomer: false,
    };
  },
  async created() {
    const vm = this;
    vm.me = await UserService.me().catch((error) => {
      this.$message({
        type: "error",
        message: error,
      });
    });
  },
};
</script>

<style lang="scss">
.uploadWrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;

  .errorReport {
    .el-card__body {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 86%;
      background-color: #fef0f0;
      color: #f56c6c;

      span {
        align-self: center;
        margin-bottom: 15px;
      }
    }
  }

  ::-webkit-scrollbar {
    width: 7px;
  }

  ::-webkit-scrollbar-track-piece {
    background-color: #eee;
    border-left: 1px solid #ccc;
  }

  ::-webkit-scrollbar-thumb:vertical,
  ::-webkit-scrollbar-thumb:horizontal {
    background-color: #a1a4a5;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb:vertical:hover,
  ::-webkit-scrollbar-thumb:horizontal:hover {
    background-color: #717171;
  }
}

.el-transfer {
  .el-transfer-panel:last-child {
    .el-transfer-panel__list {
      height: calc(100% - 40px);
    }
  }
}

// 1. Validar Campos Obrigatórios
// 2. Disparar evento de pre-postagem
// 3. Comentar itens do menu
</style>
